export default "__VITE_ASSET__D__aLBNo__"